<template>
  <form class="login-form" @submit.prevent="passwordRecovery">
    <div class="card mb-0">
      <div class="card-body">
        <div class="text-center mb-3">
          <img
            src="@/assets/img/logos/logo_mini.png"
            class="h-72px"
            alt="Logo"
          />
          <h5 class="mt-1 mb-0">Portal de Relatórios</h5>
          <span class="text-muted">Recuperar Senha</span>
        </div>
        <div class="mb-3">
          <div class="form-control-feedback form-control-feedback-start">
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': v$.email.$errors.length }"
              placeholder="usuario@email.com"
              v-model="v$.email.$model"
            />
            <div class="form-control-feedback-icon">
              <i class="ph ph-envelope text-muted" />
            </div>
            <span
              v-if="
                (v$.email.required.$invalid || v$.email.email.$invalid) &&
                v$.email.$errors.length
              "
              class="invalid-feedback"
            >
              O campo deve conter um e-mail válido
            </span>
          </div>
        </div>
        <div class="mb-3">
          <button
            type="submit"
            class="btn btn-dark w-100"
            title="Recuperar Senha"
            :disabled="v$.$invalid || disableButton"
          >
            <span v-if="disableButton">
              <i class="ph ph-spinner spinner" />
            </span>
            <span v-else>Recuperar Senha</span>
          </button>
        </div>
        <div class="text-center" title="Login">
          <router-link to="/">Login</router-link>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

export default {
  name: 'PasswordRecovery',

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      email: '',
      disableButton: false,
    }
  },

  methods: {
    async passwordRecovery() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          const response = await this.$store.dispatch(
            'passwordRecovery',
            this.email,
          )

          this.resetForm()

          if (response && response.message) {
            this.$root.$refs.notification.success(response.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        } catch (error) {
          this.resetForm()

          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },

    resetForm() {
      this.disableButton = false
      this.email = ''
      this.v$.$reset()
    },
  },

  validations() {
    return {
      email: {
        required,
        email,
      },
    }
  },
}
</script>
